import _defineProperty from '@babel/runtime/helpers/defineProperty';
import toRgbColor from './toRgbColor.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

/**
 * Mix two colors.
 *
 * @param Color Color 1
 * @param Color Color 2
 * @param number Overriding alpha
 *
 * @return CSS color string in rgba() format
 */
var mix = function mix(color, otherColor) {
  var overridingAlpha = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var parsedColor1 = toRgbColor(color);
  var color1 = _objectSpread(_objectSpread({}, parsedColor1), {}, {
    alpha: typeof (parsedColor1 === null || parsedColor1 === void 0 ? void 0 : parsedColor1.alpha) === 'number' ? parsedColor1.alpha : 1
  });
  var parsedColor2 = toRgbColor(otherColor);
  var color2 = _objectSpread(_objectSpread({}, parsedColor2), {}, {
    alpha: typeof (parsedColor2 === null || parsedColor2 === void 0 ? void 0 : parsedColor2.alpha) === 'number' ? parsedColor2.alpha : 1
  });
  var factor = color1.alpha * (1 - color2.alpha);
  var alpha = overridingAlpha !== undefined ? overridingAlpha : 1 - (1 - color2.alpha) * (1 - color1.alpha);
  var red = Math.round((color2.red * color2.alpha + color1.red * factor) / alpha);
  var green = Math.round((color2.green * color2.alpha + color1.green * factor) / alpha);
  var blue = Math.round((color2.blue * color2.alpha + color1.blue * factor) / alpha);
  return "rgba(".concat(red, ",").concat(green, ",").concat(blue, ",").concat(alpha, ")");
};

export { mix as default };
//# sourceMappingURL=mix.js.map
